<template>
    <v-container fluid fill-height>
        <v-layout justify-center>
            <v-flex xs12>
                <event-list></event-list>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import EventList from '../../components/user/EventList';

    export default {
        components: {
            'event-list': EventList
        }
    }
</script>
